import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo, { localBusinessLd, breadcrumbLd } from "@/lib/seo";

const STEPS = [
  { n: "01", t: "Décrivez votre projet", d: "Texte libre ou dictée vocale. Pas de vocabulaire technique nécessaire. Le site vous comprend en français courant." },
  { n: "02", t: "RAMA analyse les travaux", d: "Les prestations nécessaires sont détectées automatiquement (préparation, finitions, corps d'état concernés)." },
  { n: "03", t: "Obtenez votre estimation", d: "Une fourchette d'estimation ventilée par postes. Pas de fausse précision — un ordre de grandeur fiable." },
  { n: "04", t: "Planifiez la visite", d: "Choisissez votre créneau : visite technique sur site avec un conducteur de travaux, ou appel préalable." },
  { n: "05", t: "Recevez votre devis définitif", d: "Après la visite, un devis détaillé et transparent poste par poste vous est remis." },
  { n: "06", t: "Le chantier commence", d: "Un interlocuteur unique coordonne tous les corps d'état. Vous suivez l'avancement sur votre espace projet." },
  { n: "07", t: "Réception des travaux", d: "PV de réception, garanties, et remise des documents. Votre chantier est terminé." },
];

export default function CommentPage() {
  return (
    <div className="pt-[100px] md:pt-[140px] pb-24">
      <Seo
        title="Comment ça marche — De l'estimation à la réception des travaux | RAMA DÉCO"
        description="Les 7 étapes d'un chantier RAMA DÉCO : description du projet, estimation en ligne, visite technique, devis détaillé, chantier suivi en ligne et réception."
        path="/comment-ca-marche"
        jsonLd={[
          localBusinessLd(),
          breadcrumbLd([{ to: "/", label: "Accueil" }, { to: "/comment-ca-marche", label: "Comment ça marche" }]),
          {
            "@context": "https://schema.org",
            "@type": "HowTo",
            name: "Faire réaliser des travaux intérieurs avec RAMA DÉCO",
            step: STEPS.map((s, i) => ({ "@type": "HowToStep", position: i + 1, name: s.t, text: s.d })),
          },
        ]}
      />
      <div className="wrap">
        <div className="font-mono-caption text-bordeaux mb-4">Comment ça marche</div>
        <h1 className="font-display text-4xl md:text-6xl tracking-tight text-anthracite max-w-3xl">De votre idée{" "}<br/><span className="italic text-bordeaux-700">au chantier.</span></h1>
        <p className="mt-6 text-stone-600 text-lg max-w-2xl leading-relaxed">Sept étapes pensées pour la simplicité. Vous parlez normalement, RAMA gère le reste.</p>

        <div className="mt-20 relative">
          <div className="absolute left-[26px] md:left-[42px] top-4 bottom-4 w-px bg-stone-300" aria-hidden />
          <ol className="space-y-10 md:space-y-14">
            {STEPS.map(s => (
              <li key={s.n} data-testid={`step-${s.n}`} className="relative flex gap-6 md:gap-10">
                <div className="relative flex-shrink-0 w-[52px] md:w-[84px] h-[52px] md:h-[84px] rounded-full bg-[#F9F8F5] border border-stone-300 flex items-center justify-center font-display text-lg md:text-2xl text-bordeaux">{s.n}</div>
                <div className="pt-2 md:pt-4">
                  <div className="font-display text-2xl md:text-3xl text-stone-900">{s.t}</div>
                  <div className="mt-2 text-stone-600 max-w-xl leading-relaxed">{s.d}</div>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-20">
          <Link to="/estimation" className="btn-primary" data-testid="cta-comment-estimer">Commencer maintenant <ArrowRight size={16} /></Link>
        </div>
      </div>
    </div>
  );
}
